export default __webpack_public_path__ + "media/images/backgrounds/bg-12-3891fee5730217b4c61a44fa1de06a96.jpg";